import { render, staticRenderFns } from "./FaceZoneSingleSelect.vue?vue&type=template&id=be278906&scoped=true"
import script from "./FaceZoneSingleSelect.vue?vue&type=script&lang=js"
export * from "./FaceZoneSingleSelect.vue?vue&type=script&lang=js"
import style0 from "./FaceZoneSingleSelect.vue?vue&type=style&index=0&id=be278906&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be278906",
  null
  
)

export default component.exports